// src/pages/ItemAdjustment/itemAdjustmentSelectors.js
export const selectAdjustmentVoucherNo = (s) => s.itemAdjustment.voucherNo;
export const selectAdjustmentItems = (s) => s.itemAdjustment.itemsList;
export const selectAdjustmentFooter = (s) => s.itemAdjustment.footerValues;
